<template>
  <b-modal v-model="showModal">
    <div slot="modal-title">
      {{ $t('message.booking.checkout_step.invite_friends') }}
    </div>
    <section>
      <p class="text-comment">
        {{ $t('message.invite_friends.receive_credit_detail', { credits: globalState.configData.invite_friend_credits }) }}
      </p>
      <div class="mt-4">
        <h3>{{ $t('message.invite_friends.how_do_invites_work') }}</h3>
      </div>
      <div class="row mt-4">
        <div class="col-2">
          <i class="fal fa-link fa-3x -status-pending"></i>
        </div>
        <div class="col-10">
          <h4>{{ $t('message.invite_friends.how_do_invites_work_title01') }}</h4>
          <p class="text-comment">{{ $t('message.invite_friends.how_do_invites_work_detail01') }}</p>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-2">
          <i class="fal fa-hand-holding-usd fa-3x -status-new"></i>
        </div>
        <div class="col-10">
          <h4>{{ $t('message.invite_friends.how_do_invites_work_title02', { credits: globalState.configData.register_credits }) }}</h4>
          <p class="text-comment">{{ $t('message.invite_friends.how_do_invites_work_detail02', { credits: globalState.configData.register_credits }) }}</p>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-2">
          <i class="fal fa-piggy-bank fa-3x -status-new"></i>
        </div>
        <div class="col-10">
          <h4>{{ $t('message.invite_friends.how_do_invites_work_title03', { credits: globalState.configData.invite_friend_credits }) }}</h4>
          <p class="text-comment">{{ $t('message.invite_friends.how_do_invites_work_detail03', { credits: globalState.configData.invite_friend_credits }) }}</p>
        </div>
      </div>

      <div class="row mt-4 no-gutters" v-if="referralCode">
        <div class="col-12">
          <h3>{{ $t('message.invite_friends.share_your_link') }}</h3>
          <div class="input-group flex-fill">
            <input ref="referralCode"
                   class="form-control flex-fill"
                   type="text"
                   :value="'beneat.co/chat-booking?c='+referralCode.referral_code">
            <div class="input-group-append">
              <button class="btn btn-info"
                      @click="copyReferralCode()"
                      v-clipboard:copy="referralCode.url_referral_code">
                {{ $t(isCopiedReferralCode) }}
              </button>
            </div>
          </div>
          <!-- /.form-inline -->
        </div>
      </div>
    </section>
    <div slot="modal-footer" class="w-100">
      <b-btn class="float-right" variant="secondary" @click="showModal = false">
        {{ $t('message.button.close') }}
      </b-btn>
    </div>
  </b-modal>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    data () {
      return {
        showModal: false,
        refCode: null
      }
    },
    computed: {
      ...mapGetters({
        globalState: 'globalVal/getState',
        referralCode: 'referralCode/getReferralCode',
        user: 'auth/getUser'
      }),
      isCopiedReferralCode () {
        return (this.refCode) ? 'message.button.copied' : 'message.button.copy'
      }
    },
    methods: {
      showInviteFriendModal (status) {
        this.showModal = status
      },
      copyReferralCode () {
        this.refCode = this.$refs.referralCode.value
      }
    },
    mounted () {
      if (this.user) {
        this.$store.dispatch('referralCode/LOAD_REFERRAL_CODE_DETAIL', this.user.id)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/booking/components/InviteFriendModal.vue